
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-merchant",
      function () {
        return require("private-next-pages/help-merchant/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-merchant"])
      });
    }
  